import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from 'services/authentication.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';


@Component({
  selector: 'app-support-status',
  templateUrl: './support-status.component.html',
  styleUrls: ['./support-status.component.scss']
})
export class SupportStatusComponent implements OnInit {

  item: any
  referenceNumber: string
  supportHistoryList: any;
  listNotFound = false;
  rows: any[] = [];
  dataSource = new MatTableDataSource(this.rows);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = [
    "Updated On",
    "Comments"
  ];
  mailComments: any;
  dataField: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    // private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public popupdata: any,
    private dialogRef: MatDialogRef<SupportStatusComponent>,
    private userServices: UserService,) { }

  ngOnInit(): void {
    if (this.popupdata != null) {
      this.item = this.data.isshow
      this.referenceNumber = this.item.referenceNumber;
      this.mailComments = this.item.mailComments
      this.dataField = this.item

      if ((this.item.id) && (this.item.referenceNumber != null)) {
        this.userServices.getSupportHistoryList(this.item.id).subscribe((result: any) => {
          if (result) {
            this.supportHistoryList = result.value;

            if (this.supportHistoryList.length === 0) {
              this.listNotFound = true
            }
            else {
              this.listNotFound = false;

              this.dataSource = new MatTableDataSource(this.supportHistoryList);
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
            }
          }
        });
      }

    }
  }

  onCancel() {
    this.dialogRef.close();
  }


}
